// extracted by mini-css-extract-plugin
export default {"wrapper":"ArticlesList_wrapper__ljI30","card":"ArticlesList_card__gL2WS","loader":"ArticlesList_loader__Pci8O"};